import React from 'react'
import Layout from '../components/Layouts/Layout'
import { Container, Row, Col } from 'react-bootstrap'
import { ASSET_URL } from '../config/config'


const Solutions = () => {
    return (
        <>
            <Layout>
                <section className='solutions-header-bg header-bg' style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%), url(${ASSET_URL}assets/images/sliders/solution.webp)`}}>
                    <Container>
                        <Row>
                            <Col sm={12} lg={5}>
                                <div className="title">
                                    <h1 className="title-heading fs-3 mb-1">Own Your <br></br>
                                    <span>Atum Charge Station</span></h1>
                                    <p className="title-desc">By following just a few simple steps and fulfilling a few requirements, you can be an owner of an ATUM Charge franchise.</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>


                <section className="about about-1">
                    <Container>
                        <Row className="align-items-center">
                            <Col sm={12} lg={4}>
                                <div className="heading heading-12">
                                    <h2 className="heading-title">Atum Charge Benefits</h2>
                                </div>
                            </Col>
                            <Col sm={12} lg={8}>
                                <ul className="list-unstyled advantages-list">
                                    <li>Utilization of vacant space for ATUM CHARGE</li>
                                    <li>The power generated from Solar system can be utilized for powering captive loads and excess energy can be fed back to Grid</li>
                                    <li>Per day 4.5 or 5 Units (kWh), will be generated per Kilowatt (kW) system and it's required per kW area is 100 Sq. fts.</li>
                                    <li>Generation power at site, which can be used existing loads or can Charge the Electrical Vehicles (EVs) at affordable PRICE.</li>
                                    <li>Can be use EV charging points at location where vehicles tend to park.</li>
                                    <li>ATUM CHARGE models start with 1.3kW (4panels) to higher side.</li>
                                    <li>Service warranty available for 1 year for ATUM CHARGE &amp; EV Charger.</li>
                                    <li>ATUM CHARGE provides end-to-end (Turnkey) solutions for customer satisfaction.</li>
                                    <li>Payback/ROI will be gotten within a year.</li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </section>


                <section className="projects projects-grid bg-dark-gray" id="projects-grid-1">
                    <Container>
                        <div className="heading heading-8 mb-0">
                            <Row>
                                <Col lg={4}>
                                    <h2 className="heading-title text-center color-white">272</h2>
                                    <p className="text-center color-white">Charging Stations</p>
                                </Col>
                                <Col lg={4}>
                                    <h2 className="heading-title text-center color-white">12</h2>
                                    <p className="text-center color-white">Locations</p>
                                </Col>
                                <Col lg={4}>
                                    <h2 className="heading-title text-center color-white">100%</h2>
                                    <p className="text-center color-white">Customer Satisfaction</p>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>


                <section className="about about-1 bg-grey">
                    <Container>
                        <Row className="align-items-center">
                            <Col sm={12} lg={4}>
                                <div className="heading heading-12">
                                    <h2 className="heading-title">Setup Requirements </h2>
                                </div>
                            </Col>
                            <Col sm={12} lg={8}>
                                <ul className="list-unstyled advantages-list">
                                    <li>Required land area minimum 100 sft and more</li>
                                    <li>Roadside Land area preferences</li>
                                    <li>Power Supply required minimum of 2kW capacity.</li>
                                    <li>Proper Land/ Firm documents required for applying of Solar Net-metering connection.</li>
                                    <li>NOC (No Objection Certificate) required for Local permits</li>
                                    <li>For charging, sufficient parking space required</li>
                                    <li>Payment CHEQUE required for setup of ATUM CHARGE as per confirmation.</li>
                                    <li>If any Rental /Lease Agreement produce documents.</li>
                                    <li>GST &amp; PAN Card details.</li>
                                    <li>Applicant details as per the application Form.</li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </section>


            </Layout>
        </>
      )
}

export default Solutions